<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    title="管理协作者"
    okText="确认"
    width="700px"
    :zIndex="1009"
  >
    <div class="flex-b mt-10" style="height: 400px">
      <div class="flex-1 teamWorker-content">
        <a-input-search
          v-model:value="searchValue"
          placeholder="搜索成员"
          @search="onSearch"
          style="width: 100%"
          @change="inputChange"
        />
        <a-tabs
          v-model:activeKey="activeKey"
          size="small"
          class="mt-4"
          :tabBarStyle="{
            marginBottom: '10px'
          }"
        >
          <a-tab-pane key="1" tab="成员">
            <query-list
              ref="listRef"
              v-model:value="states.selectPersonList"
              url="/permission/team-user/getAllTeamUserList"
              scrollHeight="310px"
              :searchData="{
                queryType: '2',
                isQueryUser: true
              }"
              :searchParams="{
                perModuleType: '1',
                perFolderId: store.teamWorkerModalData.id
              }"
            >
              <template #item="{ record }">
                <div class="flex-b" style="width: 100%">
                  <userItem :data="record" class="flex-1"></userItem>
                  <div class="personType">{{ record.roleName }}</div>
                </div>
              </template>
            </query-list>
          </a-tab-pane>
          <a-tab-pane key="2" tab="部门" v-if="checkRunningEnvironment() == 'company'">
            Content of Tab Pane 2
          </a-tab-pane>
        </a-tabs>
      </div>
      <a-divider type="vertical" style="height: 400px" />
      <div class="flex-1 teamWorker-content">
        <div class="flex-b fs-12">
          <div>
            已选：
            <span>{{ states.selectPersonList.length }}个成员</span>
            <span v-if="checkRunningEnvironment() == 'company'">
              ，{{ states.selectDepartmentList.length }}个部门
            </span>
          </div>
          <div class="text-primary cursor-p" @click="clear">清空</div>
        </div>
        <a-tabs
          v-model:activeKey="activeKeyRight"
          size="small"
          class="mt-4"
          :tabBarStyle="{
            marginBottom: '10px'
          }"
        >
          <a-tab-pane key="1" tab="成员">
            <div class="scroll-content">
              <div class="flex-b mb-4" v-for="i in states.selectPersonList" :key="i.id">
                <div class="flex-s">
                  <userItem :data="i" :tag="true" class="flex-1"></userItem>
                </div>
                <div class="flex">
                  <a-select
                    v-model:value="i.permissionCode"
                    size="small"
                    :options="store.permissionList"
                    style="min-width: 80px"
                    class="ml-10"
                    :dropdown-match-select-width="false"
                  ></a-select>
                  <div class="cursor-p ml-10" @click="deleteItem(i)">
                    <CloseOutlined />
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="部门" v-if="checkRunningEnvironment() == 'company'">
            Content of Tab Pane 2
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import {
  Modal as AModal,
  Divider as ADivider,
  InputSearch as AInputSearch,
  Tabs as ATabs,
  TabPane as ATabPane,
  Select as ASelect,
  message
} from 'ant-design-vue'
import { CloseOutlined } from '@ant-design/icons-vue'
import { ref, reactive, watch, useAttrs } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import queryList from '@/views/aiDAM/components/queryList.vue'
import userItem from '@/views/aiDAM/components/userItem'
import checkRunningEnvironment from '@/utils/runningEnvironment.js'
import { cloneDeep } from 'lodash'
import eventsBus from '@/utils/eventsBus'
import { queryFolderCollaboratorsNotCreate, manageFolderCollaborators } from '@/service/api/aiDam'

const emits = defineEmits(['asyncSuccess'])
const attrs = useAttrs()
const store = aigcStore()
const searchValue = ref('')
const activeKey = ref('1')
const activeKeyRight = ref('1')
const confirmLoading = ref(false)
const listRef = ref(null)
const states = reactive({
  selectPersonList: [],
  selectDepartmentList: []
})

const onSearch = () => {
  listRef.value?.getList(false, {
    nickName: searchValue.value
  })
}
const inputChange = () => {
  if (!searchValue.value.length) onSearch()
}
const deleteItem = (item) => {
  states.selectPersonList = states.selectPersonList.filter((i) => i.id != item.id)
}

const clear = () => {
  states.selectPersonList = []
  states.selectDepartmentList = []
}
const handleOk = () => {
  // if (!states.selectPersonList.length && !states.selectDepartmentList.length)
  //   return message.error('请选择数据')
  confirmLoading.value = true
  if (store.teamWorkerModalData.modalType === 'data') {
    eventsBus.emit('teamUser', {
      selectPersonList: cloneDeep(
        states.selectPersonList.map((i) => {
          return {
            ...i,
            teamUserId: i.id
          }
        })
      ),
      selectDepartmentList: cloneDeep(states.selectDepartmentList)
    })
    confirmLoading.value = false
  } else {
    manageFolderCollaborators(
      {
        dirId: store.teamWorkerModalData.id,
        dirType: '1',
        permissionList: states.selectPersonList.map((i) => {
          return {
            ...i,
            teamUserId: i.id
          }
        })
      },
      store.teamWorkerModalData.id
    ).then((res) => {
      if (res?.data) {
        message.success('保存成功')
        emits('asyncSuccess', {
          selectPersonList: cloneDeep(states.selectPersonList),
          selectDepartmentList: cloneDeep(states.selectDepartmentList)
        })
        store.queryFolderCollaboratorsAction()
      }
      confirmLoading.value = false
    })
  }
}

watch(
  () => attrs.open,
  (val) => {
    activeKey.value = '1'
    activeKeyRight.value = '1'
    confirmLoading.value = false
    clear()
    if (val) {
      if (store.teamWorkerModalData.modalType === 'data') {
        states.selectPersonList = store.teamWorkerModalData.data
      } else {
        queryFolderCollaboratorsNotCreate(
          {
            dirId: store.teamWorkerModalData.id,
            dirType: '1'
          },
          store.teamWorkerModalData.id
        ).then((res) => {
          if (res.data) {
            states.selectPersonList = res.data.map((i) => {
              return {
                ...i,
                id: i.teamUserId
              }
            })
          }
        })
      }
    }
  }
)
</script>

<style lang="less" scoped>
.teamWorker-content {
  height: 100%;
}
.personType {
  border: 1px solid #ccc;
  font-size: 12px;
  padding: 2px 4px;
  margin-left: 4px;
  border-radius: 4px;
}
.scroll-content {
  height: 325px;
  overflow-y: auto;
}
:deep(.card-list) {
  max-width: none;
}
</style>
